// src/components/Pages/arShared/gadgetThemes.ts
var GADGET_THEMES = [
  {
    value: "classic",
    label: "Classic",
    blurb: "Clean white frame with a soft scanning sweep.",
    scanner: {
      hint: "Point at the object and hold steady",
      scanning: ["Scanning\u2026", "Looking for a match\u2026", "Hold steady\u2026"],
      locked: "Match found!",
      targetLabel: "Find this",
      ariaLabel: "Camera scanner"
    },
    detector: {
      scanning: ["Searching for a signal\u2026", "Move around to find it\u2026"],
      warmer: "Warmer",
      colder: "Colder",
      steady: "Signal steady",
      near: "Very close\u2026",
      found: "Signal found!",
      dialLabel: "SIGNAL",
      ariaLabel: "Signal detector"
    },
    spell: {
      drawing: "Keep going, finish where you started\u2026",
      fizzled: "The spell fizzled! Try again, all in one go.",
      cast: "The spell is cast!",
      ariaLabel: "Spell casting"
    },
    blaster: {
      body: "#2ec4b6",
      barrel: "#3a86ff",
      tip: "#ff9f1c",
      ring: "#ffd166",
      scope: "#9b5de5",
      decal: "#ffffff",
      // The original muzzle-flash core colour (RING_YELLOW), so the classic
      // blaster renders byte-for-byte as it did before themes existed.
      flash: "#ffd166"
    },
    accent: { primary: "#3a86ff", secondary: "#ffd166", glow: "#ffffff" }
  },
  {
    value: "scifi",
    label: "Retro sci-fi",
    blurb: "Green phosphor display, scanlines and a sweeping sensor bar.",
    scanner: {
      hint: "Align the target inside the brackets",
      scanning: [
        "SCANNING SECTOR\u2026",
        "ANALYSING SIGNAL\u2026",
        "CALIBRATING SENSOR\u2026",
        "PATTERN SEARCH\u2026"
      ],
      locked: "TARGET LOCKED",
      targetLabel: "Target data",
      ariaLabel: "Sci-fi sensor scanner"
    },
    detector: {
      scanning: ["SCANNING SECTOR\u2026", "TRIANGULATING\u2026"],
      warmer: "WARMER",
      colder: "COLDER",
      steady: "SIGNAL STEADY",
      near: "TARGET NEAR",
      found: "TARGET ACQUIRED",
      dialLabel: "SENSOR",
      ariaLabel: "Sensor readout"
    },
    spell: {
      drawing: "TRACING PATTERN\u2026",
      fizzled: "PATTERN REJECTED. RETRACE IN ONE PASS.",
      cast: "PATTERN ACCEPTED",
      ariaLabel: "Pattern tracer"
    },
    blaster: {
      body: "#414a52",
      barrel: "#b9c6cf",
      tip: "#4dff9a",
      ring: "#8affc6",
      scope: "#2f6f52",
      decal: "#d6ffe9",
      flash: "#c9ffe2"
    },
    accent: { primary: "#4dff9a", secondary: "#0f9e5e", glow: "#b8ffdd" }
  },
  {
    value: "steampunk",
    label: "Steampunk",
    blurb: "Brass porthole, turning cogs and a warm sepia lens.",
    scanner: {
      hint: "Turn the lens upon the object and hold it still",
      scanning: [
        "Winding the mechanism\u2026",
        "Focusing the aetheric lens\u2026",
        "Consulting the ledger\u2026",
        "Gears engaging\u2026"
      ],
      locked: "Specimen identified",
      targetLabel: "Specimen",
      ariaLabel: "Brass lens scanner"
    },
    detector: {
      scanning: ["The needle stirs\u2026", "Winding the aetherscope\u2026"],
      warmer: "Warmer",
      colder: "Colder",
      steady: "The needle holds\u2026",
      near: "The needle quivers\u2026",
      found: "Specimen located",
      dialLabel: "AETHER",
      ariaLabel: "Aetherscope readout"
    },
    spell: {
      drawing: "The aether takes the shape\u2026",
      fizzled: "The aether dispersed. Once more, in a single motion.",
      cast: "The mechanism is charmed!",
      ariaLabel: "Aetheric tracer"
    },
    blaster: {
      body: "#5c3a1e",
      barrel: "#c9992e",
      tip: "#b87333",
      ring: "#e2b45a",
      scope: "#8a5a2b",
      decal: "#f3e6c8",
      flash: "#ffdca8"
    },
    accent: { primary: "#e2b45a", secondary: "#b87333", glow: "#ffe6b0" }
  },
  {
    value: "spy",
    label: "Secret agent",
    blurb: "Crosshair, red laser sweep and an HQ data readout.",
    scanner: {
      hint: "Scan the target for hidden messages",
      scanning: [
        "DECRYPTING\u2026",
        "SEEKING HIDDEN MESSAGE\u2026",
        "CHECKING HQ FILES\u2026",
        "ENHANCING\u2026"
      ],
      locked: "MESSAGE FOUND",
      targetLabel: "Case file",
      ariaLabel: "Agent scanner"
    },
    detector: {
      scanning: ["SWEEPING FOR SIGNAL\u2026", "TRACING\u2026"],
      warmer: "STRONGER",
      colder: "WEAKER",
      steady: "TRACE STEADY",
      near: "SOURCE CLOSE",
      found: "SOURCE LOCATED",
      dialLabel: "TRACE",
      ariaLabel: "Signal trace readout"
    },
    spell: {
      drawing: "DRAWING THE SIGIL\u2026",
      fizzled: "SIGIL FAILED. REDRAW IN ONE MOVE.",
      cast: "SIGIL ACCEPTED",
      ariaLabel: "Sigil tracer"
    },
    blaster: {
      body: "#1e1e21",
      barrel: "#4a4f57",
      // Toy-blaster orange tip on the matte-black body: reads as a toy, and
      // keeps the muzzle-flash fringe and its spill light visible.
      tip: "#ff7a1f",
      ring: "#3a3f47",
      scope: "#ff3b3b",
      decal: "#ff3b3b",
      flash: "#ffd0d0"
    },
    accent: { primary: "#ff3b3b", secondary: "#4a4f57", glow: "#ff9a9a" }
  },
  {
    value: "enchanted",
    label: "Enchanted",
    blurb: "Glowing rune ring and drifting sparkles.",
    scanner: {
      hint: "Hold the magic lens over the object",
      scanning: [
        "Weaving the spell\u2026",
        "Reading the runes\u2026",
        "Gathering starlight\u2026",
        "The lens is searching\u2026"
      ],
      locked: "The magic is revealed!",
      targetLabel: "Seek this",
      ariaLabel: "Enchanted lens scanner"
    },
    detector: {
      scanning: ["Feeling for the magic\u2026", "The lens hums softly\u2026"],
      warmer: "Warmer",
      colder: "Colder",
      steady: "The magic hums\u2026",
      near: "The magic tingles\u2026",
      found: "The magic is here!",
      dialLabel: "MAGIC",
      ariaLabel: "Magic sensing lens"
    },
    spell: {
      drawing: "The starlight follows your wand\u2026",
      fizzled: "The spell fizzled! Draw it in one flowing stroke.",
      cast: "The spell is cast!",
      ariaLabel: "Spell weaving"
    },
    blaster: {
      body: "#b48cf2",
      barrel: "#7c3aed",
      tip: "#f7e2a0",
      ring: "#f2c94c",
      scope: "#d8a8ff",
      decal: "#ffffff",
      flash: "#fff3c4"
    },
    accent: { primary: "#d8a8ff", secondary: "#f2c94c", glow: "#ffffff" }
  },
  {
    value: "pumpkin",
    label: "Pumpkin patch",
    blurb: "Orange glow, friendly jack-o'-lantern grin and drifting leaves.",
    scanner: {
      hint: "Point the lantern at the object and hold steady",
      scanning: [
        "Sniffing out pumpkin magic\u2026",
        "The lanterns flicker\u2026",
        "Something spooky and silly is near\u2026"
      ],
      locked: "Pumpkin magic found!",
      targetLabel: "Find this",
      ariaLabel: "Pumpkin lantern scanner"
    },
    detector: {
      scanning: ["Sniffing for pumpkin magic\u2026", "The lantern flickers\u2026"],
      warmer: "Warmer",
      colder: "Colder",
      steady: "The lantern glows\u2026",
      near: "The pumpkin grins\u2026",
      found: "Pumpkin magic found!",
      dialLabel: "SPOOK-O-METER",
      ariaLabel: "Pumpkin spook-o-meter"
    },
    spell: {
      drawing: "The pumpkin magic follows your wand\u2026",
      fizzled: "Fizzle! Draw the whole shape without stopping.",
      cast: "Pumpkin magic cast!",
      ariaLabel: "Pumpkin spell casting"
    },
    blaster: {
      body: "#ff8f2e",
      barrel: "#5b21b6",
      tip: "#ffd27a",
      ring: "#6d8a3d",
      scope: "#2f1656",
      decal: "#1a1a1a",
      flash: "#ffd27a"
    },
    accent: { primary: "#ff8f2e", secondary: "#7c3aed", glow: "#ffd27a" }
  }
];
var DEFAULT_GADGET_THEME = "classic";
var BY_VALUE = Object.fromEntries(
  GADGET_THEMES.map((t) => [t.value, t])
);
function resolveGadgetTheme(theme) {
  return BY_VALUE[theme ?? DEFAULT_GADGET_THEME] ?? BY_VALUE[DEFAULT_GADGET_THEME];
}
var gadgetThemeClass = (spec) => `vm-theme-${spec.value}`;
var toScannerSpec = (spec) => ({
  value: spec.value,
  label: spec.label,
  blurb: spec.blurb,
  ...spec.scanner
});
var SCANNER_THEMES = GADGET_THEMES.map(toScannerSpec);
var DEFAULT_SCANNER_THEME = DEFAULT_GADGET_THEME;
function resolveScannerTheme(theme) {
  return toScannerSpec(resolveGadgetTheme(theme));
}
var scannerThemeClass = gadgetThemeClass;

export {
  GADGET_THEMES,
  DEFAULT_GADGET_THEME,
  resolveGadgetTheme,
  gadgetThemeClass,
  SCANNER_THEMES,
  DEFAULT_SCANNER_THEME,
  resolveScannerTheme,
  scannerThemeClass
};
//# sourceMappingURL=chunk-XXDZHRIA.mjs.map